(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-deck-portfolio-52kards"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.custom-deck-portfolio-52kards__grid a');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const dialog = link.closest('.custom-deck-portfolio-52kards').querySelector('dialog');
      if (!dialog.showModal) return;
      event.preventDefault();
      const image = dialog.querySelector('img');
      image.src = link.href;
      image.alt = link.querySelector('img').alt;
      dialog.showModal();
      dialog.addEventListener('close', () => link.focus({ preventScroll: true }), { once: true });
    }
    const dialog = event.target.closest('.custom-deck-portfolio-52kards__dialog');
    if (dialog && (event.target === dialog || event.target.closest('button'))) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
